import { createContext, useContext } from 'react'

import hasPermission from './hasPermission'

const NoRender = () => null

const PermissionContext = createContext([])
const usePemissionContext = () => useContext(PermissionContext)

const Authorized = (props) => {
  const { fallback = <NoRender />, children, permissions: requiredPermission, requires = 'all' } = props
  const availablePermissions = usePemissionContext()

  if (!hasPermission(requiredPermission, availablePermissions, requires)) {
    return fallback
  }

  return children
}

export const PermissionProvider = PermissionContext.Provider
export default Authorized
